module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-year-2022-32aab057041364db981807e92065e8dc.svg";